export default "__VITE_ASSET__DFq2dz7g__"